export default __webpack_public_path__ + "59947f73bf8f491f9965062826ce8eb0.png";